import OmniApiClient from "./base";

const RESOURCE = "/qogita";

export const qogitaApi = {
  listCredentials: (params = {}) =>
    OmniApiClient.get(`${RESOURCE}/credentials/`, { params }),

  createCredential: (data) =>
    OmniApiClient.post(`${RESOURCE}/credentials/`, data),

  updateCredential: (id, data) =>
    OmniApiClient.put(`${RESOURCE}/credentials/${id}`, data),

  deleteCredential: (id) =>
    OmniApiClient.delete(`${RESOURCE}/credentials/${id}`),

  testCredentials: (data) =>
    OmniApiClient.post(`${RESOURCE}/credentials/test`, data),

  testStoredCredential: (id) =>
    OmniApiClient.post(`${RESOURCE}/credentials/${id}/test`),

  listWatchlist: (page = 1, pageSize = 50, search = "", qogitaStatus = "") =>
    OmniApiClient.get(`${RESOURCE}/watchlist/`, {
      params: {
        page,
        page_size: pageSize,
        search: search || undefined,
        qogita_status:
          qogitaStatus && qogitaStatus !== "all" ? qogitaStatus : undefined,
      },
    }),

  addWatchlistItem: (data) =>
    OmniApiClient.post(`${RESOURCE}/watchlist/`, data),

  updateWatchlistItem: (gtin, data) =>
    OmniApiClient.patch(`${RESOURCE}/watchlist/${gtin}`, data),

  restoreWatchlistItem: (gtin) =>
    OmniApiClient.post(
      `${RESOURCE}/watchlist/${encodeURIComponent(gtin)}/restore`,
    ),

  deleteWatchlistItem: (gtin) =>
    OmniApiClient.delete(`${RESOURCE}/watchlist/${gtin}`),

  getCatalogStatus: () => OmniApiClient.get(`${RESOURCE}/catalog/status`),

  getCatalogDownloadPrefs: () =>
    OmniApiClient.get(`${RESOURCE}/catalog/download-prefs`),

  saveCatalogDownloadPrefs: (data) =>
    OmniApiClient.put(`${RESOURCE}/catalog/download-prefs`, data),

  listCatalogCategories: () =>
    OmniApiClient.get(`${RESOURCE}/catalog/categories`),

  setupCatalogWebhook: () =>
    OmniApiClient.post(`${RESOURCE}/catalog/setup-webhook`),

  requestCatalogDownload: (data = {}) =>
    OmniApiClient.post(`${RESOURCE}/catalog/request-download`, data),
};
